export function getGuideBoxSourceRect(_a) {
    var cameraWidth = _a.cameraWidth, cameraHeight = _a.cameraHeight, naturalWidth = _a.naturalWidth, naturalHeight = _a.naturalHeight, marginWidth = _a.marginWidth, marginHeight = _a.marginHeight, isLandscape = _a.isLandscape, documentBorderWidth = _a.documentBorderWidth, guideRect = _a.guideRect;
    var coverScale = Math.max(cameraWidth / naturalWidth, cameraHeight / naturalHeight);
    var coverCropX = (naturalWidth * coverScale - cameraWidth) / 2;
    var coverCropY = (naturalHeight * coverScale - cameraHeight) / 2;
    if (guideRect) {
        return {
            sx: (guideRect.left + coverCropX) / coverScale,
            sy: (guideRect.top + coverCropY) / coverScale,
            sWidth: guideRect.width / coverScale,
            sHeight: guideRect.height / coverScale,
        };
    }
    if (isLandscape) {
        return {
            sx: ((12 + documentBorderWidth) + coverCropX) / coverScale,
            sy: (((cameraHeight - marginWidth) / 2) + coverCropY) / coverScale,
            sWidth: marginHeight / coverScale,
            sHeight: marginWidth / coverScale,
        };
    }
    return {
        sx: ((((cameraWidth - marginWidth) / 2) + documentBorderWidth) + coverCropX) / coverScale,
        sy: ((12 + documentBorderWidth) + coverCropY) / coverScale,
        sWidth: marginWidth / coverScale,
        sHeight: marginHeight / coverScale,
    };
}
